import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_2123_16883)" }, [
      _createElementVNode("path", {
        fill: "#E28A00",
        d: "M0 10.53C0 13.814 2.125 16 5.917 16h1.956c.466 0 .77-.343.77-.763a.743.743 0 0 0-.77-.763H5.926c-2.887 0-4.42-1.715-4.42-4.03 0-2.307 1.533-3.919 4.42-3.919h5.807l2.633-.12-.152-.394-2.1 1.818-2.438 2.409a.7.7 0 0 0-.203.523c0 .446.296.755.745.755a.79.79 0 0 0 .55-.24l4.978-4.948A.78.78 0 0 0 16 5.762a.78.78 0 0 0-.254-.574L10.768.24a.83.83 0 0 0-.55-.24c-.449 0-.745.309-.745.755 0 .222.068.385.203.523l2.438 2.418 2.1 1.809.152-.395-2.633-.12h-5.68C2.184 4.99 0 7.254 0 10.53"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_2123_16883" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }